export default "__VITE_ASSET__DcEvw9oO__"